module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal zoom",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "id": "modalNaoExportou"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-md",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('table', [_c('tbody', _vm._l((_vm.fichas), function(f) {
    return _c('tr', {
      key: f
    }, [_vm._m(1, true), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "2px 0"
      }
    }, [_vm._v("Não conseguimos exportar a ficha "), _c('strong', [_vm._v(" " + _vm._s(f) + " ")])])])
  }), 0)]), _vm._v(" "), _c('small', {
    staticStyle: {
      "font-size": "11.5px"
    }
  }, [_vm._v("Tente novamente mais tarde. Caso o problema persista, por favor, entre em contato com a área de Projetos.")])]), _vm._v(" "), _vm._m(2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title text-left"
  }, [_vm._v("Fichas de Aprovação que não foram exportadas")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "color": "red"
    }
  }, [_c('i', {
    staticClass: "fa fa-remove",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Fechar")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0487755f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/modal/NaoExportou.vue
// module id = 278
// module chunks = 1